import React, { useState, useEffect } from 'react';
import { Search, Plus, Edit, Trash2, Save, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const NominationForm = ({ visa, onClose }) => {
    const [formData, setFormData] = useState({
        attachmentsCount: '',
        originalAttachmentsCount: '',
        nameArabic: '',
        profession: '',
        visaNumber: visa?.VisaNumber || '',
        visaDate: visa?.IssueDate ? new Date(visa.IssueDate).toLocaleDateString('ar') : '',
        companyName: '',
        engazNumber: '',
        barcode: null,
        photo: null
    });

    return (
        <div className="bg-white p-8 rounded-lg shadow-lg">
            <div className="relative">
                {/* رأس النموذج */}
                <div className="text-center mb-6">
                    <h1 className="text-2xl font-bold mb-4">( استمارة ترشيح عمل )</h1>
                    <div className="flex justify-between text-lg mb-4">
                        <div>
                            عدد المرفقات
                            <input 
                                type="text"
                                className="mx-2 border rounded px-2 w-16 text-center"
                                value={formData.attachmentsCount}
                                onChange={(e) => setFormData({...formData, attachmentsCount: e.target.value})}
                            />
                        </div>
                        <div>
                            عدد اصول المرفقات
                            <input 
                                type="text"
                                className="mx-2 border rounded px-2 w-16 text-center"
                                value={formData.originalAttachmentsCount}
                                onChange={(e) => setFormData({...formData, originalAttachmentsCount: e.target.value})}
                            />
                        </div>
                    </div>
                </div>

                {/* المحتوى الرئيسي */}
                <div className="space-y-6">
                    <div className="text-xl font-bold">
                        سعادة رئيس القسم القنصلي بالسويس
                    </div>

                    <div className="text-lg">
                        السلام عليكم ورحمة الله وبركاته
                    </div>

                    <div className="space-y-4 text-lg">
                        <div>
                            نرشح لكم بطيه الجواز الخاص بالسيد/
                            <input 
                                type="text"
                                className="mx-2 border-b border-gray-400 w-64 focus:outline-none focus:border-blue-500"
                                value={formData.nameArabic}
                                onChange={(e) => setFormData({...formData, nameArabic: e.target.value})}
                            />
                        </div>
                        <div>
                            نأمل التكرم منكم بالتأشير له على مهنة
                            <input 
                                type="text"
                                className="mx-2 border-b border-gray-400 w-48 focus:outline-none focus:border-blue-500"
                                value={formData.profession}
                                onChange={(e) => setFormData({...formData, profession: e.target.value})}
                            />
                        </div>
                        <div>
                            بموجب التأشيرة رقم
                            <input 
                                type="text"
                                className="mx-2 border-b border-gray-400 w-48 focus:outline-none focus:border-blue-500"
                                value={formData.visaNumber}
                                readOnly
                            />
                        </div>
                        <div>
                            وتاريخ
                            <input 
                                type="text"
                                className="mx-2 border-b border-gray-400 w-48 focus:outline-none focus:border-blue-500"
                                value={formData.visaDate}
                                readOnly
                            />
                        </div>
                        <div>
                            والصادرة لـ
                            <input 
                                type="text"
                                className="mx-2 border-b border-gray-400 w-64 focus:outline-none focus:border-blue-500"
                                value={formData.companyName}
                                onChange={(e) => setFormData({...formData, companyName: e.target.value})}
                            />
                        </div>
                        <div>
                            رقم إنجاز
                            <input 
                                type="text"
                                className="mx-2 border-b border-gray-400 w-48 focus:outline-none focus:border-blue-500"
                                value={formData.engazNumber}
                                onChange={(e) => setFormData({...formData, engazNumber: e.target.value})}
                            />
                        </div>
                    </div>

                    {/* منطقة الباركود والصورة */}
                    <div className="mt-8 space-y-6">
                        <div className="relative border-2 border-dashed border-gray-400 p-4 h-32 flex items-center justify-center">
                            {formData.barcode ? (
                                <img 
                                    src={formData.barcode} 
                                    alt="باركود"
                                    className="max-h-full"
                                />
                            ) : (
                                <div className="text-center">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="hidden"
                                        id="barcode-upload"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                const reader = new FileReader();
                                                reader.onloadend = () => {
                                                    setFormData({...formData, barcode: reader.result});
                                                };
                                                reader.readAsDataURL(file);
                                            }
                                        }}
                                    />
                                    <label 
                                        htmlFor="barcode-upload"
                                        className="cursor-pointer text-gray-500 hover:text-gray-700"
                                    >
                                        انقر لإضافة الباركود
                                    </label>
                                </div>
                            )}
                        </div>

                        <div className="relative border-2 border-dashed border-gray-400 p-4 h-48 flex items-center justify-center">
                            {formData.photo ? (
                                <img 
                                    src={formData.photo} 
                                    alt="الصورة الشخصية"
                                    className="max-h-full"
                                />
                            ) : (
                                <div className="text-center">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        className="hidden"
                                        id="photo-upload"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                const reader = new FileReader();
                                                reader.onloadend = () => {
                                                    setFormData({...formData, photo: reader.result});
                                                };
                                                reader.readAsDataURL(file);
                                            }
                                        }}
                                    />
                                    <label 
                                        htmlFor="photo-upload"
                                        className="cursor-pointer text-gray-500 hover:text-gray-700"
                                    >
                                        انقر لإضافة الصورة الشخصية
                                    </label>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* التوقيعات */}
                    <div className="mt-8 flex justify-between">
                        <div className="text-center">
                            <div className="border border-gray-400 w-32 h-32"></div>
                            <div className="mt-2">ختم المكتب</div>
                        </div>
                        <div className="text-center">
                            <div className="border border-gray-400 w-32 h-32"></div>
                            <div className="mt-2">توقيع المدير</div>
                        </div>
                    </div>
                </div>

                {/* أزرار التحكم */}
                <div className="mt-8 flex justify-end space-x-4">
                    <button
                        onClick={() => window.print()}
                        className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600"
                    >
                        طباعة
                    </button>
                    <button
                        onClick={onClose}
                        className="bg-gray-500 text-white px-6 py-2 rounded-lg hover:bg-gray-600"
                    >
                        إغلاق
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NominationForm;